import React from 'react'

const Footer = (props) => {
    return (
        <footer className="py-5 bg-dark mt-4">
            <div className="container">
                <p className="m-0 text-center text-white">Copyright &copy; Wesley Mendes 2017</p>
            </div>
        </footer>
    )
}
export default Footer


// WEBPACK FOOTER //
// ./src/Footer.js